import { useStore } from '@/store/useStore';
import { cn } from '@/ui/lib/utils';
import './progressBar.css';

interface ProgressBarProps {
    className?: string;
}

export const ProgressBar = ({ className }: ProgressBarProps) => {
    const progress = useStore((state) => state.betProgress ?? 0);

    return (
        <div className={cn('progress-bar', className)}>
            <div className="progress-bar__progress" style={{ width: `${progress * 100}%` }} />
        </div>
    );
};
